export default {
  "nl": {
    "question_list": {
      "actions": {
        "cancel": "Annuleren",
        "delete": "Verwijderen",
        "deleteMultipleQuestionLists": "Verwijder...",
        "delete_cancel": "Annuleren",
        "edit": "Bewerken",
        "new": "Nieuwe FAQ",
        "save": "Opslaan",
        "submit": "Aanmaken",
        "tickBoxesDeletion": "Selecteer de FAQ lijsten die je wil verwijderen."
      },
      "attributes": {
        "description": "Omschrijving",
        "name": "Naam",
        "question_list": "FAQ"
      },
      "labels": {
        "allUnits": "Alle Units",
        "descriptionOptional": "Omschrijving (optioneel)",
        "editFAQ": "Wijzigen FAQ Lijst",
        "info": "Heb je een vraag over jouw huis? Hou dan deze pagina in het oog en blijf op de hoogte van de meest gestelde vragen en hun antwoorden!",
        "questions": " Geen Vragen | 1 Vraag | {count} Vragen",
        "showQuestionListFor": "Toon de FAQ's voor",
        "title": "FAQ"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Hier zal je antwoorden vinden op algemene vragen of vragen gesteld door anderen.",
            "title": "Veelgestelde vragen"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Voorzie antwoorden op algemene vragen die je klanten kunnen hebben.",
            "title": "Maak je eerste FAQ lijst aan"
          }
        }
      },
      "toasts": {
        "create": "FAQ Lijst aangemaakt",
        "delete": "FAQ lijst verwijderd",
        "update": "FAQ lijst gewijzigd"
      },
      "validation": {
        "needName": "Verplicht veld",
        "selectQuestionList": "Selecteer ten minste 1 FAQ"
      }
    }
  }
}